"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _pickers = require("@material-ui/pickers");
var _DateRangeRounded = _interopRequireDefault(require("@material-ui/icons/DateRangeRounded"));
var _lodash = require("lodash");
var _dateFns = require("date-fns");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    wrapper: (0, _defineProperty2.default)({
      margin: theme.spacing(4, 0)
    }, theme.breakpoints.up('md'), {
      margin: theme.spacing(1.5, 0),
      '&:nth-child(1)': {
        marginBottom: theme.spacing(4)
      },
      '&:last-child': {
        paddingBottom: 0
      }
    }),
    label: {
      display: 'block',
      marginBottom: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 1.43
    },
    keyboardDatePicker: {
      '& input': (0, _defineProperty2.default)({
        padding: theme.spacing(3.5)
      }, theme.breakpoints.up('md'), {
        padding: theme.spacing(3, 1, 2, 4)
      })
    }
  };
});
var overrideTheme = (0, _core.createTheme)({
  overrides: {
    MuiOutlinedInput: {
      adornedEnd: {
        paddingRight: '5px'
      }
    },
    MuiIconButton: {
      root: {
        padding: '6px'
      }
    }
  }
});
var DateControl = function DateControl(props) {
  var label = props.label,
    onChange = props.onChange,
    state = props.state,
    placeholder = props.placeholder,
    _props$dateFormat = props.dateFormat,
    dateFormat = _props$dateFormat === void 0 ? 'DD MMM YYYY' : _props$dateFormat,
    datePickerProps = props.datePickerProps,
    _props$ariaLabel = props.ariaLabel,
    ariaLabel = _props$ariaLabel === void 0 ? 'change start date' : _props$ariaLabel;
  var classes = useStyles();
  var _React$useState = _react.default.useState((0, _lodash.uniqueId)('date-picker')),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 1),
    uniqueId = _React$useState2[0];
  var theme = (0, _styles.useTheme)();
  return __jsx("div", {
    className: classes.wrapper
  }, __jsx(_core.Typography, {
    component: "label",
    className: classes.label,
    htmlFor: uniqueId,
    id: 'label-' + uniqueId,
    dangerouslySetInnerHTML: {
      __html: label
    }
  }), __jsx(_styles.ThemeProvider, {
    theme: overrideTheme
  }, __jsx(_pickers.KeyboardDatePicker, (0, _extends2.default)({}, datePickerProps, {
    format: dateFormat,
    clearable: true,
    value: state && (0, _dateFns.toDate)(state),
    onChange: onChange,
    emptyLabel: placeholder,
    inputVariant: "outlined",
    id: uniqueId,
    className: classes.keyboardDatePicker,
    keyboardIcon: __jsx(_DateRangeRounded.default, {
      style: {
        color: theme.palette.action.focus
      }
    }),
    KeyboardButtonProps: {
      'aria-label': ariaLabel
    }
  }))));
};
var _default = DateControl;
exports.default = _default;